
import { Toast, Notify, Dialog } from "vant";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState([
      "vuex_system",
      "vuex_pre_login",
      "vuex_installed_wx",
      "vuex_app_serve",
      "vuex_env_available"
    ]),
  },
  data() {
    return {
      type: "",
      phone: "",
      code: "",
      time: 60000,
      showDialog: false,
      checked: false,
      sending: false,
      sended: false,
      loginType: "",
    };
  },
  mounted() {
    // 一键登录
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.vuex_app_serve == "uniapp") {
          this.getLoginToken();
        }
      }, 500);
    })
    this.type = this.$route.query.type ?? "";
    // 一键登录回调
    this.$bus.$on("loginToken", (data) => {
      let params = {
        accessToken: data,
      };
      Toast.clear();
      let url = "/app/artapi.php?r=login.getMobile";
      this.$axios.$post(url, params).then((res) => {
        this.login_next(res);
      });
    })
    // 微信登录回调
    this.$bus.$on("wxAuthCallBack", (data) => {
      let params = {
        code: data,
      };
      Toast.clear();
      let url = "/app/artapi.php?r=ralfqbk.app_wx_login";
      this.$axios.$post(url, params).then((res) => {
        this.login_next(res);
      });
    });
    // 苹果登录回调
    this.$bus.$on("appleAuthCallBack", (data) => {
      let res = JSON.parse(data);
      if (res.errMsg == "getUserInfo:ok") {
        let { openId, email } = res.userInfo;
        let params = {
          u_openid: openId,
        };
        this.$axios
          .$post("/app/artapi.php?r=ralfqbk.app_login", params)
          .then((res) => {
            this.login_next(res);
          });
      } else {
        Toast.fail(err.msg ?? "登陆失败,请尝试其他登陆方式");
      }
    });
  },
  methods: {
    // 一键登录
    getLoginToken() {
      // window.uni.postMessage({
      //   data: {
      //     name: "getLoginToken"
      //   }
      // });
      // return;
      window.uni.postMessage({
        data: {
          name: "evalJs",
          value: `aLiSDKModule.checkEnvAvailable(2, (result) => {
					if ("600000" == result.resultCode) {
						const config = {
							uiConfig: {
								setPrivacyAlertIsNeedShow: false, //二次弹窗是否显示  默认false
								setNavHidden: "false", //是否隐藏导航栏，默认不隐藏（true：隐藏，false：不隐藏）
								// setLogoHidden: 'false', //是否隐藏中间的Logo图片，默认不隐藏（true：隐藏，false：不隐藏）
								// setSloganHidden: "false", //是否隐藏slogan文案，默认不隐藏（true：隐藏，false：不隐藏）
								setSwitchHidden: "true", //是否隐藏“切换方式”按钮（true：隐藏，false：不隐藏）
								setCheckboxHidden: "false", //是否隐藏隐私协议前面的勾选框（true：隐藏，false：不隐藏，如果隐藏代表用户强制同意协议，请谨慎使用）
								//授权页背景相关设置
								setBackgroundUi: {
									backgroundColor: "#FFFFFF", //授权页背景色，如果是弹窗的话就是弹窗部分的背景色（ps：在加载图片或者视频时，可以设置跟第一帧接近的背景色，这样可以避免在资源加载期间出现白屏效果）
								},
								setNavUi: {
									bgColor: '#2972fa', //导航栏背景色（注：只针对全屏生效，弹窗时无该属性）
								},
								setLogoUi: {
									imgPath: "static/image/login/ic_login_logo_black.png", //logo图片资源路径
									top: "20", //距离父容器顶部偏移，注意后面不要加单位（Android默认为dp，iOS默认为pt）
									left: "20",
									width: "150", //该控件宽度，注意后面不要加单位（Android默认为dp，iOS默认为pt）
									height: "150" //该控件高度，注意后面不要加单位（Android默认为dp，iOS默认为pt）
								},
								setNumberUi: {
									// textColor: "#FFFFFF", //掩码文字颜色
									textSize: "20", //文字大小，注意后面不要加单位（Android默认为sp，iOS默认为pt）
									// left: "20", //距离父容器左侧偏移，不设置则默认居中，注意后面不要加单位（Android默认为dp，iOS默认为pt）
									// top: "20", //距离父容器顶部偏移，注意后面不要加单位（Android默认为dp，iOS默认为pt）
								},
								//登录按钮相关设置，水平方向默认居中
								setLoginBtnUi: {
									textColor: "#FFFFFF", //登录按钮标题颜色
									color: "#2972fa", //当imgPath或者activeImgPath、invalidImgPath、hightedImgPath属性为空时使用color属性作为按钮背景填充色
								},
							}
						}
						aLiSDKModule.getLoginToken(
							5000,
							config,
							tokenResult => {
								console.log(tokenResult);
								if ("600001" == tokenResult.resultCode) {
									console.log("授权页拉起成功")
								} else if ("600000" == tokenResult.resultCode) {
									let pages = getCurrentPages();
									let page = pages[pages.length - 1];
									let currentWebview = page.$getAppWebview();
									let wv = currentWebview.children()[0];
									wv.evalJS("login_token('" + tokenResult.token + "')"); // 支付完成
									//手动关闭授权页
									aLiSDKModule.quitLoginPage()
								} else {
									console.log("手动关闭授权页")
									//其他失败情况，手动关闭授权页
									aLiSDKModule.quitLoginPage()
								}
							},
							tokenCallback => {
								switch (tokenCallback.resultCode) {
										case "700000":
											console.log("用户点击返回按钮")
											break
										case "700001":
											console.log("用户切换其他登录方式")
											break
										case "700002":
											//通过isChecked字段可以得到checkbox是否勾选，未勾选可以用自定义Toast进行提示
											if (tokenCallback.result && !tokenCallback.result.isChecked) {
												plus.nativeUI.toast('请勾选同意协议');
											}
											console.log("用户点击登录按钮用户点击登录按钮")
											break
										case "700003":
											console.log("用户点击checkBox")
											break
										case "700004":
											console.log("用户点击协议")
											break
										case "700010":
											//调用userControlAuthPageCancel后方可使用
											console.log("用户点击返回按钮，Android专用");
											aLiSDKModule.quitLoginPage()
											break
										case "700011":
											//调用userControlAuthPageCancel后方可使用
											console.log("用户使用物理返回键，Android专用");
											aLiSDKModule.quitLoginPage()
											break
									}
								
								// if (tokenCallback.result && tokenCallback.result.isChecked == false) {
								// 	uni.showToast({
								// 		icon: "none",
								// 		title: "请勾选同意协议"
								// 	})
								// }
							},
							clickResult => {
								console.log(clickResult);
								switch (clickResult.resultCode) {
									case "700000":
										console.log("用户点击返回按钮")
										break
									case "700001":
										console.log("用户切换其他登录方式")
										break
									case "700002":
										//通过isChecked字段可以得到checkbox是否勾选，未勾选可以用自定义Toast进行提示
										if (clickResult.result && !clickResult.result.isChecked) {
											uni.showToast({
												icon: "none",
												title: "请勾选同意协议",
												duration: 3000,
											})
										}
										console.log("用户点击登录按钮用户点击登录按钮")
										break
									case "700003":
										console.log("用户点击checkBox")
										break
									case "700004":
										console.log("用户点击协议")
										break
									case "700010":
										//调用userControlAuthPageCancel后方可使用
										console.log("用户点击返回按钮，Android专用");
										aLiSDKModule.quitLoginPage()
										break
									case "700011":
										//调用userControlAuthPageCancel后方可使用
										console.log("用户使用物理返回键，Android专用");
										aLiSDKModule.quitLoginPage()
										break
								}
							},
							customUiResult => {
								//这里回调的是自定义控件的点击事件，通过 customUiResult.widgetId 来识别自定义控件，然后做一些自己的处理
							}
						)

					} else {
						console.log("当前环境不支持一键登录，result = ", JSON.stringify(result));
						// uni.showToast({
						// 	icon: "none",
						// 	title: result.msg,
						// 	duration: 3000,
						// });
					}
				});`
        },
      });
    },
    // 是否阅读并同意
    isChecked(loginType) {
      this.loginType = loginType;
      let { checked } = this;
      if (checked) {
        return true;
      } else {
        this.showDialog = true;
      }
    },
    // 确认登录
    confirmLogin() {
      this.checked = true;
      let { loginType } = this;
      switch (loginType) {
        case "appleLogin":
          this.appleLogin();
          break;
        case "wxLogin":
          this.wxLogin();
          break;
        default:
          this.login();
          break;
      }
    },
    async appleLogin() {
      let ischecked = await this.isChecked("appleLogin");
      if (!ischecked) {
        return;
      }
      if (this.vuex_app_serve == "uniapp") {
        const toast = Toast.loading({
          duration: 3000, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // toast.clear();
        // apple授权登录
        window.uni.postMessage({
          data: {
            name: "appleAuth",
          },
        });
        return;
      } else {
        let _this = this;
        var Apple = api.require("Apple");
        let url = "/app/artapi.php?r=ralfqbk.app_login";
        const toast = Toast.loading({
          duration: 3000, // 持续展示 toast
          forbidClick: true,
          message: "登录中",
        });
        Apple.login((ret, err) => {
          toast.clear();
          if (ret.status) {
            let { user, email } = ret.authInfo;
            let params = {
              u_openid: user,
              email: email,
            };
            _this.$axios.$post(url, params).then((res) => {
              _this.login_next(res);
            });
          } else {
            Toast.fail(err.msg ?? "登陆失败,请尝试其他登陆方式");
          }
        });
      }
    },
    async wxLogin() {
      let ischecked = await this.isChecked("wxLogin");
      if (!ischecked) {
        return;
      }
      let _this = this;
      if (this.vuex_app_serve == "uniapp") {
        // uniapp引入模块
        const toast = Toast.loading({
          duration: 3000, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        // toast.clear();
        // 微信授权登录
        window.uni.postMessage({
          data: {
            name: "wxAuth",
          },
        });
        return;
      } else {
        // apicloud引入模块
        var wxPlus = api.require("wxPlus");
        const toast = Toast.loading({
          duration: 3000, // 持续展示 toast
          forbidClick: true,
          message: "加载中",
        });
        wxPlus.auth({}, function (ret, err) {
          toast.clear();
          if (ret.status) {
            let params = {
              code: ret.code,
            };
            _this.$axios
              .$post("/app/artapi.php?r=ralfqbk.app_wx_login", params)
              .then((res) => {
                _this.login_next(res);
              });
          } else {
            alert(err.code);
          }
        });
      }
    },
    back() {
      if (this.type == "") {
        this.$router.back();
      } else {
        this.$router.replace({
          path: "/",
        });
      }
    },
    async login() {
      let ischecked = await this.isChecked("login");
      if (!ischecked) {
        return;
      }
      let url = "/app/artapi.php?r=login.login";
      let { phone, code } = this;
      let params = {
        phone,
        code,
      };
      this.$axios.$post(url, params).then((res) => {
        this.login_next(res);
      });
    },
    finish() {
      this.sended = false;
    },
    //获取验证码
    getCode() {
      const toast = Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      this.$axios
        .$post("/app/artapi.php?r=login.send_sms", {
          phone: this.phone,
          code: this.code,
        })
        .then((res) => {
          this.sended = true;
          toast.clear();
          if (res.code == 200) {
            Notify({ type: "success", message: "验证码已发送" });
            this.$nextTick(() => {
              this.$refs.countDown.start();
            })
          }
        });
    },
    login_next(res) {
      if (res.code == 200) {
        if (process.client) {
          this.$cookies.set("token", res.data.token);
          localStorage.setItem("token", res.data.token);
          if (this.vuex_system == "DOUYINAPP") {
            this.$store.dispatch("getUserInfo"); // 获取用户信息
            Toast.success("登陆成功");
            window.tt.miniProgram.redirectTo({
              url: "/pages/index/index?token=" + res.data.token,
            });
            window.tt.miniProgram.postMessage({
              data: {
                type: "setToken",
                token: res.data.token,
              },
            });
            return;
          }
          if (this.vuex_system == "ios" || this.vuex_system == "android") {
            if (this.vuex_app_serve == "uniapp") {
              window.uni.postMessage({
                data: {
                  name: "setPrefs",
                  data: {
                    key: "token",
                    value: res.data.token,
                  },
                },
              });
            } else {
              api.setPrefs({
                key: "token",
                value: res.data.token,
              });
              // 上报注册量
              // var openinstall = api.require("openinstall");
              // openinstall.reportRegister();
            }
          }
          this.$store.dispatch("getUserInfo"); // 获取用户信息
          Toast.success("登陆成功");
          this.$router.replace({ path: "/" });
        }
      }
      if (res.code == 201) {
        Toast.success("注册成功,请前去完善基础信息!");
        this.$cookies.set("token", res.data.token);
        if (this.vuex_system == "DOUYINAPP") {
          window.tt.miniProgram.postMessage({
            data: {
              type: "setToken",
              token: res.data.token,
            },
          });
          return;
        }
        if (this.vuex_system == "ios" || this.vuex_system == "android") {
          if (this.vuex_app_serve == "uniapp") {
            window.uni.postMessage({
              data: {
                name: "setPrefs",
                data: {
                  key: "token",
                  value: res.data.token,
                },
              },
            });
          } else {
            api.setPrefs({
              key: "token",
              value: res.data.token,
            });
          }
        }
        this.$router.replace({
          path: "/user/editProvince",
        });
      }
    },
  },
};
